import styled from '@emotion/styled';
import cursorImage from '@hotjar/webapp-ng/src/playbacks/img/icon-cursor.svg';

export const PreviewCursorContainer = styled.div<{ show: boolean; zoom: number }>`
  position: absolute;
  background-color: transparent;
  z-index: 4;

  & > div {
    display: ${({ show }) => (show ? 'block' : 'none')};
    width: ${({ zoom }) => 44 / zoom}px;
    height: ${({ zoom }) => 44 / zoom}px;

    background-image: url(${cursorImage});
    background-size: contain;
    -webkit-transition: all 90ms linear;
    -moz-transition: all 90ms linear;
    -o-transition: all 90ms linear;
    -ms-transition: all 90ms linear;
    transition: all 90ms linear;
  }
`;

export const PreviewContainer = styled.div<{
  zoom: number;
  windowSize: undefined | number[];
}>`
  transform: scale(${({ zoom }) => zoom});

  & > div {
    transform: translate(-50%, -50%);
    width: ${({ windowSize }) => (windowSize ? `${windowSize[0]}px` : 'auto')};
    height: ${({ windowSize }) => (windowSize ? `${windowSize[1]}px` : 'auto')};
  }
`;
